import { z } from 'zod';
import { BaseApplicationDTOSchema, ApplicationStatusSchema, } from "./applications.dto.js";
import { createPaginatedQuerySchema, } from "../../../../common/types/pagination.js";
// Search filters schema
export const ApplicationSearchFiltersSchema = z.object({
    search: z.string().optional(),
    name: z.string().optional(),
    cpf: z.string().optional(),
    status: z.union([ApplicationStatusSchema, z.array(ApplicationStatusSchema)]).optional(),
    startDate: z.string().optional(),
    endDate: z.string().optional(),
    companyIds: z.union([z.string().uuid(), z.array(z.string().uuid())]).optional(),
    facilityIds: z.union([z.string().uuid(), z.array(z.string().uuid())]).optional(),
});
// Combined pagination with search filters schema
const PaginationWithSearchSchema = createPaginatedQuerySchema(ApplicationSearchFiltersSchema);
export const FindApplicationsByFacilityRequestDTOSchema = z.object({
    params: z.object({
        companyId: BaseApplicationDTOSchema.shape.companyId,
        facilityId: BaseApplicationDTOSchema.shape.facilityId,
    }),
    query: PaginationWithSearchSchema,
});
//# sourceMappingURL=find-applications-by-facility.dto.js.map